import BaseUseCase from "../../../base_use_case.js";
import Routes from "../../../../admin/routes.js";
class ListCountriesUseCase extends BaseUseCase {

  execute(params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/admin/addresses/countries`,
      params: params
    }).then((result) => {
      let { data, headers } = result; 
      let { countries } = data; 

      countries = countries.map((country) => {
        return {
          ...country,
          key: country.id,
          itemLink: Routes.country(country)
        }
      })
      data.list = countries;
      return {
        data: data,
        headers: headers
      }
    })
  }
}

const instance = new ListCountriesUseCase();
export default instance;